export { default as GigAssPrompt } from './GigAssPrompt'
